import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { LogOut, Home, Users } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const { user, logout, isAdmin, role } = useAuth();
  const { displayName, logoUrl } = useBranding();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => navigate(isAdmin ? '/admin' : '/dashboards')}>
          {logoUrl && <img className="navbar-logo" src={logoUrl} alt="" />}
          <h2>{displayName}</h2>
        </div>
        
        <div className="navbar-menu">
          {isAdmin && (
            <button className="nav-link" onClick={() => navigate('/admin')}>
              <Home size={18} />
              Admin Panel
            </button>
          )}

          {role === 'company_admin' && (
            <button className="nav-link" onClick={() => navigate('/company')}>
              <Users size={18} />
              My company
            </button>
          )}
          
          <button className="nav-link" onClick={() => navigate('/dashboards')}>
            <Home size={18} />
            Dashboards
          </button>
          
          <div className="navbar-user">
            <span className="user-name">{user?.username}</span>
            <span className="user-role">({user?.role})</span>
          </div>
          
          <button className="nav-link logout-btn" onClick={handleLogout}>
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
